export const PLAYERS = [
  {
    id: 'p1',
    nick: 'NyxDream',
    handle: '@nyxdream',
    gameId: '417 822 9101',
    region: 'EU • Москва',
    rank: 'Mythic V',
    role: 'Mid Lane',
    altRoles: ['Tank', 'Support'],
    bio: 'Ищу команду на ранкед. Войс есть, играю стабильно вечером. Без токсиков.',
    activity: 'Был 2 часа назад',
    online: true,
    age: 22,
    gender: 'Ж',
    av: 'av-3',
    game: 'mlbb',
  },
  {
    id: 'p2',
    nick: 'Voidwalker',
    handle: '@voidwalker_pro',
    gameId: '904 117 5523',
    region: 'CIS • Минск',
    rank: 'Legend',
    role: 'Jungle',
    altRoles: ['EXP'],
    bio: 'Главное — командная игра. Микрофон, вечерами 19–24. Beat them all.',
    activity: 'Был 5 минут назад',
    online: true,
    age: 24,
    gender: 'М',
    av: 'av-1',
    game: 'mlbb',
  },
  {
    id: 'p3',
    nick: 'Lumicore',
    handle: '@lumi.core',
    gameId: '288 401 7720',
    region: 'EU • Киев',
    rank: 'AR 56',
    role: 'DPS',
    altRoles: ['Sub-DPS', 'Healer'],
    bio: 'Co-op в Геншин по выходным. Нужна стабильная пати на абиссы.',
    activity: 'Был 12 дней назад',
    online: false,
    age: 19,
    gender: 'Ж',
    av: 'av-2',
    game: 'genshin',
  },
  {
    id: 'p4',
    nick: 'KillSwitch',
    handle: '@killswitch',
    gameId: '512 998 0044',
    region: 'CIS • СПб',
    rank: 'Conqueror',
    role: 'Assault',
    altRoles: ['Sniper'],
    bio: 'Squad TPP / FPP. Ищу 3-х адекватов на ранкед PUBG. Гарнитура есть.',
    activity: 'В сети сейчас',
    online: true,
    age: 26,
    gender: 'М',
    av: 'av-4',
    game: 'pubg',
  },
];

export const GAMES = {
  mlbb: { name: 'Mobile\nLegends', short: 'MLBB', cls: 'gb-mlbb', tag: 'Bang Bang' },
  magic_chess: { name: 'Magic\nChess', short: 'MC', cls: 'gb-magic-chess', tag: 'Moonton' },
  genshin: { name: 'Genshin\nImpact', short: 'GNS', cls: 'gb-genshin', tag: 'HoYoverse' },
  pubg: { name: 'PUBG\nMobile', short: 'PUBG', cls: 'gb-pubg', tag: 'Krafton' },
  honkai: { name: 'Honkai\nStar Rail', short: 'HSR', cls: 'gb-honkai', tag: 'HoYoverse' },
  zzz: { name: 'Zenless\nZone Zero', short: 'ZZZ', cls: 'gb-zzz', tag: 'HoYoverse' },
  csgo: { name: 'Counter\nStrike', short: 'CS', cls: 'gb-csgo', tag: 'Valve' },
  valorant: { name: 'Valorant', short: 'VAL', cls: 'gb-valorant', tag: 'Riot' },
};

export const MY_PROFILES = [
  { game: 'mlbb', status: 'active', nick: 'NyxDream', rank: 'Mythic V', role: 'Mid Lane' },
  { game: 'genshin', status: 'paused', nick: 'NyxDream', rank: 'AR 58', role: 'DPS' },
  { game: 'pubg', status: 'empty' },
  { game: 'valorant', status: 'empty' },
];

export const CHATS = [
  { id: 'c1', nick: 'Voidwalker', av: 'av-1', last: 'Го катку?', time: '21:42', unread: 3, online: true },
  { id: 'c2', nick: 'KillSwitch', av: 'av-4', last: 'Ок, кидай инвайт', time: '20:11', unread: 0, online: true },
  { id: 'c3', nick: 'Lumicore', av: 'av-2', last: 'Привет 👋', time: 'Вчера', unread: 1, online: false },
  { id: 'c4', nick: 'Aether.7', av: 'av-7', last: 'Скинь свой ID', time: 'Вчера', unread: 0, online: false },
  { id: 'c5', nick: 'Pixelcat', av: 'av-6', last: 'Спасибо за катку!', time: 'Пн', unread: 0, online: false },
];

export const ACTIVITY = [
  { id: 'mylikes', icon: '❤', label: 'Мои лайки', count: 47, accent: 'pink' },
  { id: 'incoming', icon: '💘', label: 'Кто меня лайкнул', count: 12, accent: 'pink' },
  { id: 'mutual', icon: '🔥', label: 'Взаимные', count: 5, accent: 'orange' },
  { id: 'subs', icon: '👥', label: 'Подписчики', count: 89, accent: 'blue' },
  { id: 'subscr', icon: '⭐', label: 'Подписки', count: 31, accent: 'purple' },
  { id: 'friends', icon: '🤝', label: 'Друзья', count: 18, accent: 'green' },
];
